import { FC, useState } from 'react'
import { ListItemText, MenuItem, OutlinedInput, Select } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import { SelectDropdownIcon } from 'ui/components/svg'
import { Wrapper, StyledFormControl, menuProps } from './templateSortSelect.styles'

interface Props {
  options: string[]
  value: string
  handleChange: (e: any) => void
}

const TemplateSortSelect: FC<Props> = ({ options, handleChange, value }) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  return (
    <Wrapper>
      <StyledFormControl isopen={anchorEl ? 'true' : 'false'}>
        <Select
          displayEmpty
          MenuProps={{
            ...menuProps,
            PaperProps: {
              ...menuProps.PaperProps,
              sx: {
                ...menuProps.PaperProps.sx,
                display: anchorEl ? 'block' : 'none'
              }
            },
            anchorEl,
            open: Boolean(anchorEl),
            onClose: () => setAnchorEl(null)
          }}
          sx={{
            '& .MuiSelect-icon': { transform: anchorEl ? 'rotate(180deg)' : 'rotate(0deg)' }
          }}
          IconComponent={(props) => (
            <SelectDropdownIcon {...props} className={`${props.className} ${anchorEl ? 'is-open' : ''}`} />
          )}
          renderValue={() => value}
          inputProps={{ 'aria-label': 'Sort by' }}
          value={value}
          onChange={handleChange}
          input={<OutlinedInput onMouseDown={handleClick} />}
        >
          {options.map((option) => (
            <MenuItem key={option} value={option} onClick={() => setAnchorEl(null)}>
              <ListItemText primary={option} />
              {value === option && <CheckIcon />}
            </MenuItem>
          ))}
        </Select>
      </StyledFormControl>
    </Wrapper>
  )
}

export default TemplateSortSelect
